import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Generic } from '../../models/generic';
import { LoginData } from '../../models/login-data';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  url = environment.url
  accessToken$ = new BehaviorSubject<string | null>(null);

  private http = inject(HttpClient);

  login = (payload: object): Observable<Generic<LoginData>> => {
    return this.http.post<Generic<LoginData>>(`${this.url}/auth/login`, payload).pipe(
      tap(tokens => {
        if (tokens.data.accessToken && tokens.data.refreshToken) {
          this.setTokens(tokens.data.accessToken, tokens.data.refreshToken);
        }
      })
    );
  }

  setTokens = (access: string, refresh: string) => {
    this.accessToken$.next(access);
    localStorage.setItem('accessToken', access);
    localStorage.setItem('refreshToken', refresh);
  }

  getAccessToken = (): string | null => {
    return this.accessToken$.value || localStorage.getItem('accessToken');
  }

  getRefreshToken = (): string | null => {
    return localStorage.getItem('refreshToken');
  }

  refreshToken = (): Observable<Generic<LoginData>> => {
    return this.http.post<Generic<LoginData>>(`${this.url}/auth/refresh`, {
      refreshToken: this.getRefreshToken(),
    }).pipe(
      tap(tokens => {
        if (tokens.data.accessToken && tokens.data.refreshToken) {
          this.setTokens(tokens.data.accessToken, tokens.data.refreshToken);
        }
      })
    );
  }

  removeTokens = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    this.accessToken$.next(null)
  }

  logout = (payload: object) => {
    return this.http.post(`${this.url}/auth/logout`, payload);
  }

  changePassword = (payload: object) => {
    return this.http.post(`${this.url}/auth/change-password`, payload);
  }

  isTokenExpired(): boolean {
    const token = this.getAccessToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp * 1000;
      return Date.now() > exp;
    } catch {
      return true;
    }
  }

}

